import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import LandingLayout from './components/LandingLayout';
import Section from './components/Section';
import FeaturesGrid from './components/FeaturesGrid';
import NewspaperShowcase from './components/NewspaperShowcase';
import HowItWorksSection from './components/HowItWorksSection';
import PrivacySection from './components/PrivacySection';
import CTASection from './components/CTASection';

const PLATFORM_INTEGRATIONS = [
  'Nearpod',
  'BrainPOP',
  'Amplify',
  'CKLA',
  'EL Education',
];

export default function FeaturesPage() {
  return (
    <LandingLayout>
      {/* Hero */}
      <Section background="#F8FAFD" py={{ xs: 8, md: 12 }}>
        <Box sx={{ textAlign: 'center', maxWidth: 750, mx: 'auto' }}>
          <Typography
            variant="h1"
            sx={{
              fontSize: { xs: '2rem', md: '3rem' },
              fontWeight: 800,
              color: '#163567',
              mb: 2,
            }}
          >
            The Writing Layer for Every Curriculum
          </Typography>
          <Typography
            sx={{
              fontSize: { xs: '1.05rem', md: '1.2rem' },
              color: '#555',
              lineHeight: 1.7,
              mb: 4,
            }}
          >
            Take any lesson from your favorite platform and layer structured writing to support deeper learning across all subjects.
            Simply enter any topic, paste a lesson, or upload an assignment.
          </Typography>

          {/* Platform compatibility */}
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              flexWrap: 'wrap',
              gap: 2,
              mt: 3,
            }}
          >
            <Typography sx={{ fontSize: '0.85rem', color: '#888', alignSelf: 'center', mr: 1 }}>
              Works with:
            </Typography>
            {PLATFORM_INTEGRATIONS.map((name) => (
              <Box
                key={name}
                sx={{
                  px: 2,
                  py: 0.75,
                  borderRadius: '8px',
                  backgroundColor: '#FFFFFF',
                  border: '1px solid #E8EDF5',
                  fontSize: '0.85rem',
                  fontWeight: 600,
                  color: '#163567',
                }}
              >
                {name}
              </Box>
            ))}
          </Box>
        </Box>
      </Section>

      <FeaturesGrid />
      <NewspaperShowcase />
      <HowItWorksSection />

      {/* Capabilities */}
      <Section background="#FFFFFF">
        <Box sx={{ textAlign: 'center', mb: { xs: 4, md: 6 } }}>
          <Typography
            variant="h2"
            sx={{
              fontSize: { xs: '1.75rem', md: '2.25rem' },
              fontWeight: 800,
              color: '#163567',
              mb: 2,
            }}
          >
            Built for Real Classrooms
          </Typography>
        </Box>
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr', md: '1fr 1fr 1fr 1fr' },
            gap: 3,
          }}
        >
          {[
            { title: 'Grades 2-12', desc: 'Age-appropriate scaffolds that grow with students' },
            { title: '6+ Languages', desc: 'Multilingual support for diverse learners' },
            { title: 'All Subjects', desc: 'From science to social studies to ELA' },
            { title: 'Diverse Learners', desc: 'Accessible scaffolds for every student' },
          ].map((item) => (
            <Box key={item.title} sx={{ textAlign: 'center', p: 3 }}>
              <Typography sx={{ fontWeight: 700, fontSize: '1.1rem', color: '#163567', mb: 1 }}>
                {item.title}
              </Typography>
              <Typography sx={{ fontSize: '0.85rem', color: '#666', lineHeight: 1.6 }}>
                {item.desc}
              </Typography>
            </Box>
          ))}
        </Box>
      </Section>

      <PrivacySection />
      <CTASection />
    </LandingLayout>
  );
}
